import { combineEpics } from "redux-observable";
import { rootEpic as rootEpic$1 } from "./views/Create/epics/AnalysisConfigCreate.epics.js";
import { rootEpic as rootEpic$2 } from "./views/Edit/epics/AnalysisConfigEdit.epics.js";
import { rootEpic as rootEpic$3 } from "./views/List/epics/AnalysisConfigList.epics.js";
const rootEpic = combineEpics(rootEpic$1, rootEpic$2, rootEpic$3);
export {
  rootEpic as default,
  rootEpic
};
//# sourceMappingURL=epics.js.map
